import React from 'react';
import { Col, Row } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import styles from './student-card.module.css';

const StudentCard = ({ studentName }) => {
  return (
    <Col className={styles.student_container_wrapper}>
      <Row>
        <Col>
          <div className={styles.workgroup_card}>
            <FontAwesomeIcon className={styles.student_icon} icon={faUser} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles.student_name_label}>
            <h4>{studentName}</h4>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default StudentCard;
